export const SITE_URL = "https://www.tapadasaodomingos.com";

export const BUSINESS = {
  name: "Tapada de São Domingos",
  description:
    "Private luxury villa rentals in Porto by the Douro river",
  descriptionPt:
    "Aluguer de villas privadas de luxo no Porto junto ao rio Douro",
  email: "tapada.de.s.domingos@gmail.com",
  phones: ["+351224540858", "+351935280777"],
  priceRange: "€€€",
  checkinTime: "16:00",
  checkoutTime: "12:00",
  image: `${SITE_URL}/logo.png`,
  address: {
    streetAddress:
      "Tapada de São Domingos, km 11,8 da EN 108 Porto - Entre os Rios, Zebreiros",
    addressLocality: "Foz do Sousa",
    addressRegion: "Porto",
    postalCode: "4515-658",
    addressCountry: "PT",
  },
  geo: {
    latitude: 41.0727025,
    longitude: -8.5097015,
  },
  amenities: [
    "Private pool",
    "Free Wi-Fi",
    "Air conditioning",
    "Fully equipped kitchen",
    "Electric vehicle charger",
    "Garden",
    "River views",
  ],
};

export const BUSINESS_IDS = {
  lodging: `${SITE_URL}/#lodging`,
  website: `${SITE_URL}/#website`,
  organization: `${SITE_URL}/#organization`,
};
